import React from 'react';
import { FileText, Download, ExternalLink, Calendar, Tag } from 'lucide-react';

const GazettePublicationCard = ({ gazette }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
      <div className="p-6">
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="flex-shrink-0 w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
            <FileText className="w-6 h-6 text-indigo-600" />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            {/* Title */}
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {gazette?.title}
            </h3>

            {/* Summary */}
            <p className="text-sm text-gray-600 mb-3 line-clamp-2">
              {gazette?.summary}
            </p>

            {/* Metadata */}
            <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                <span>{formatDate(gazette?.publicationDate)}</span>
              </div>
              {gazette?.gazetteReference && (
                <div className="flex items-center gap-1">
                  <Tag className="w-4 h-4" />
                  <span className="font-medium">{gazette?.gazetteReference}</span>
                </div>
              )}
            </div>

            {/* Tags */}
            {gazette?.tags && gazette?.tags?.length > 0 && (
              <div className="flex items-center gap-2 mb-4 flex-wrap">
                {gazette?.tags?.slice(0, 3)?.map((tag, index) => (
                  <span key={index} className="text-xs text-indigo-700 bg-indigo-50 px-2 py-1 rounded">
                    {tag}
                  </span>
                ))}
              </div>
            )}

            {/* Effective Date */}
            {gazette?.effectiveDate && (
              <div className="mb-3 p-2 bg-amber-50 border border-amber-200 rounded text-sm">
                <span className="font-medium text-amber-900">Effective: </span>
                <span className="text-amber-700">{formatDate(gazette?.effectiveDate)}</span>
              </div>
            )}

            {/* Actions */}
            <div className="flex items-center gap-3">
              {gazette?.sourceUrl && (
                <a
                  href={gazette?.sourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
                >
                  <Download className="w-4 h-4" />
                  Download PDF
                </a>
              )}
              <button className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors">
                <ExternalLink className="w-4 h-4" />
                View Details
              </button>
            </div>
          </div>
        </div>

        {/* Affected Departments */}
        {gazette?.affectedDepartments && gazette?.affectedDepartments?.length > 0 && (
          <div className="mt-4 pt-4 border-t border-gray-100">
            <div className="text-sm">
              <span className="font-medium text-gray-700">Relevant to: </span>
              <span className="text-gray-600">
                {gazette?.affectedDepartments?.join(', ')}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GazettePublicationCard;